/**
 * Что за курс у препарата.
 *
 * Отдельный модуль, потому что ответ нужен и планировщику приёмов, и их
 * состоянию, и экранам — а держать его в одном из них значило бы связать их
 * между собой ради одной строки.
 */

import type { Medication } from '@/shared/db/schema';

/**
 * Строит ли приложение приёмы для этого препарата.
 *
 * Один вопрос — один ответ на всё приложение. Проверок «а не „по
 * необходимости“ ли это» по коду было полдюжины, и каждая новая причина не
 * строить расписание требовала найти их все. Причин теперь две: приём по факту
 * потребности и лекарство, которое просто лежит в аптечке.
 */
export function hasDoseSchedule(medication: Pick<Medication, 'courseType'>): boolean {
  return medication.courseType !== 'asNeeded' && medication.courseType !== 'none';
}

/**
 * Карточки, которые показывает таблетница.
 *
 * Лекарство, которое просто лежит в аптечке, курсом не является: у него нет
 * ни расписания, ни приверженности, ни журнала приёмов. В списке курсов оно
 * выглядело бы забытым назначением — и предлагало бы «продлить» то, чего не
 * начинали.
 */
export function selectCourses(medications: readonly Medication[]): Medication[] {
  return medications.filter((medication) => medication.courseType !== 'none');
}
